/**
 * Field-chip saves rebuild mappings from mapped schema fields only, so metadata stored outside
 * those chips must be copied forward or unrelated schema edits will clear it.
 */
export const preserveMappingMetadata = <
  TSource extends object,
  TMapping extends object,
  TKey extends keyof TSource & string,
>(
  source: TSource | null | undefined,
  rebuiltMapping: TMapping,
  metadataKeys: readonly TKey[],
): TMapping & Partial<Pick<TSource, TKey>> => {
  if (!source) {
    return rebuiltMapping;
  }

  const preservedMetadata: Partial<Record<TKey, TSource[TKey]>> = {};

  metadataKeys.forEach(metadataKey => {
    const metadataValue = source[metadataKey];
    if (metadataValue !== undefined) {
      preservedMetadata[metadataKey] = metadataValue;
    }
  });

  if (Object.keys(preservedMetadata).length === 0) {
    return rebuiltMapping;
  }

  return {
    ...rebuiltMapping,
    ...preservedMetadata,
  } as TMapping & Partial<Pick<TSource, TKey>>;
};
